import { render, staticRenderFns } from "./EBooks.vue?vue&type=template&id=afdc3902"
import script from "./EBooks.vue?vue&type=script&lang=js"
export * from "./EBooks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports